import bsn from 'libraries/bootstrap-native.js';
import events from 'events.js';
import http from 'http.js';
import ko from 'knockout';
import {page} from 'page.js';
import user from 'accounts/models/user.js';

import 'ko/validators.js';
import 'ko/bindings/stop_binding.js';
import 'ko/elements/autocomplete.js';

ko.bindingHandlers.askQuestionTooltip = {
    init(elem) {
        const contentId = elem.getAttribute('data-popover-content');
        const content = document.getElementById(contentId).innerHTML;
        const template = `
            <div class="popover">
                <div class="popover-content hidden-sm hidden-xs">
                    ${content}
                </div>
            </div>`;
        setTimeout(function () {
            new bsn.Popover(elem, {
                trigger: 'hover',
                placement: 'right',
                template: template.trim(),
            });
        });
    },
};

class AskQuestionManager {
    constructor() {
        this.page = ko.observable('ask');
        this.authType = ko.observable('register');
        this.maxSubject = 70;
        this.subject = ko.observable('').extend({
            maxLength: this.maxSubject,
            required: true,
        });
        this.maxBody = 1000;
        this.body = ko.observable('').extend({
            maxLength: this.maxBody,
            required: true,
        });
        this.subjectLimit = ko.pureComputed(() => {
            const charsLeft = this.maxSubject - this.subject().length;
            return charsLeft > 0 ? charsLeft : 0;
        });
        this.bodyLimit = ko.pureComputed(() => {
            const charsLeft = this.maxBody - this.body().length;
            return charsLeft > 0 ? charsLeft : 0;
        });
        this.topics = ko.observableArray([
            {
                id: null,
                name: ko.observable(''),
            },
        ]);
        this.isAnonymous = ko.observable('false');
        this.verifyAge = ko.observable().extend({checked: true});
        this.verifyUnderstanding = ko.observable().extend({checked: true});
        this.termsAgree = ko.observable();
        this.user = user;
        this.user.registrationUsername.rules.remove(
            (item) => item.rule === 'required',
        );

        this.errors = ko.validation.group(this);
        this.saving = ko.observable(false);
        this.saving = ko.observable(false);

        this.addTopic = this.addTopic.bind(this);
    }

    addTopic() {
        this.topics.push({
            id: null,
            name: ko.observable(''),
        });
    }

    async askQuestion() {
        if (this.errors().length) {
            page.alert(
                page.alertTypes.ERROR,
                'Please fix form errors to continue.',
            );
            this.errors.showAllMessages();
            return;
        }

        if (!this.user.id()) {
            this.page('authenticate');
            setTimeout(function () {
                document.getElementById('auth-heading').scrollIntoView(true);
            });
            return;
        }

        this.saving(true);
        try {
            const obj = await http.post({
                url: '/api/qa/v1/threads/',
                data: {
                    subject: this.subject(),
                    body: this.body(),
                    communities: this.topics()
                        .map((t) => t.id)
                        .filter((id) => id),
                    is_anonymous: this.isAnonymous() === 'true',
                },
            });
            window.location = obj.url;
        } catch (ex) {
            page.alert(
                page.alertTypes.ERROR,
                'Error creating question. Please try again.',
            );
            this.saving(false);
        }
    }

    async login() {
        this.saving(true);
        try {
            await this.user.login();
            page.alert(page.alertTypes.SUCCESS, 'Login successful.');
            this.page('ask');
        } catch (ex) {
            page.alert(page.alertTypes.ERROR, 'Login failed.');
        } finally {
            this.saving(false);
        }
    }

    async register() {
        this.saving(true);
        try {
            await this.user.registerAndLogin();
            page.alert(page.alertTypes.SUCCESS, 'Signup successful.');
            this.page('ask');
        } catch (ex) {
            page.alert(page.alertTypes.ERROR, 'Signup failed.');
        } finally {
            this.saving(false);
        }
    }

    async load() {
        await events.ready();
        await user.load();
        ko.applyBindings(this);
    }
}

new AskQuestionManager().load();
